import script from "./QuizQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizQuestion.vue?vue&type=script&setup=true&lang=js"

import "./QuizQuestion.vue?vue&type=style&index=0&id=7bcf0fc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bcf0fc8"]])

export default __exports__